/* eslint-disable zillow/react/prop-types */
import type { ReactElement } from 'react';
import React from 'react';

import { Box } from '@zillow/constellation';

import { HERO_HEADLINE } from '../../constants/text';
import StickySearchBox from '../StickySearchBox/StickySearchBox';
import HeroHeadline from './HeroHeadline';
import OmpHeroImage from './OmpHeroImage';

const HeroContainer: React.FC = (): ReactElement => {
    const headerWidth = '@media (max-width: 889px)'; // This breakpoint does not exist in Constellation
    const lgLte = '@media $lg_lte';
    const mdLte = '@media $md_lte';
    const smLte = '@media $sm_lte';
    return (
        <Box
            sx={{
                'display': 'flex',
                'minHeight': '408px',
                'padding': '$spacing.sm',
                'position': 'relative',
                'flexDirection': 'row',
                'alignItems': 'center',
                'justifyContent': 'center',
                '& img': {
                    backgroundColor: '$colors.blue375',
                },
                [headerWidth]: {
                    marginTop: '-60px',
                    minHeight: '488px',
                },
                [mdLte]: {
                    paddingRight: '$spacing.xl',
                    paddingLeft: '$spacing.xl',
                },
                [smLte]: {
                    minHeight: '308px',
                    padding: '$spacing.sm',
                },
            }}
        >
            <Box
                sx={{
                    width: '700px',
                    maxWidth: '100%',
                    [lgLte]: {
                        width: '480px',
                    },
                    [mdLte]: {
                        width: '100%',
                    },
                }}
            >
                <HeroHeadline headerText={HERO_HEADLINE} />
                <StickySearchBox />
            </Box>
            <OmpHeroImage />
        </Box>
    );
};

export default HeroContainer;
